import { Daycohost } from '../constants/constants';

export function getToken() {
    return localStorage.getItem('token');
}

export function isEmployee() {
    const user: any = localStorage.getItem('user');
    return JSON.parse(user).username.search('@daycohost') > 0;
}

export function isCustomer() {
    const company: any = localStorage.getItem('company');
    return JSON.parse(company).id !== Daycohost.id;
}

export function getUserContactId() {
    const contact: any = localStorage.getItem('userInfo');
    const contactId: any = JSON.parse(contact).id;
    return contactId;
}

export function getUserContactName() {
    const contact: any = localStorage.getItem('userInfo');
    const contactName: any = JSON.parse(contact).name;
    return contactName;
}

export function getUserContactLastName() {
    const contact: any = localStorage.getItem('userInfo');
    const contactLastName: any = JSON.parse(contact).lastName;
    return contactLastName;
}

export function getUserContactIdentification() {
    const contact: any = localStorage.getItem('userInfo');
    const contactIdentification: any = JSON.parse(contact).ci; // cambiar el nombre ci
    return contactIdentification;
}

export function getUserContactPhoneNumber() {
    const contact: any = localStorage.getItem('userInfo');
    const contactPhoneNumber: any = JSON.parse(contact).phone;
    return contactPhoneNumber;
}

export function getCustomerId() {
    const customer: any = localStorage.getItem('company');
    const customerId: any = JSON.parse(customer).id;
    return customerId;
}

export function getCustomerName() {
    const customer: any = localStorage.getItem('company');
    const customerId: any = JSON.parse(customer).name;
    return customerId;
}

export function getCustomerCategoryId() {
    const customer: any = localStorage.getItem('company');
    const categoryId: any = JSON.parse(customer).category.id;
    return categoryId;
}

export function getUserPrivileges() {
    const role: any = localStorage.getItem('role');
    return JSON.parse(role).rolePrivileges;
}

export function clearUserData() {
    localStorage.clear();
}

export function getUserCompany() {
    return localStorage.getItem('company');
}
